import React from 'react';

import { pxToRem } from '../utils';

type EvaneosToolsProviderValue = {
    pxToRem: (px: number) => string;
};

export const EvaneosToolsContext =
    /* #__PURE__ */
    React.createContext<EvaneosToolsProviderValue>({ pxToRem: () => '' });

type EvaneosToolsProviderProps = {
    children: React.ReactNode;
    rootHtmlFontSize: number;
};

/**
 * Use this Context Provider any Evaneos ETS related tools or data that are not mean to change often.
 * If you want to expose a changing data, create another provider
 * Create different hooks to expose it's data as needed
 */
export const EvaneosToolsProvider = ({ children, rootHtmlFontSize }: EvaneosToolsProviderProps) => (
    <EvaneosToolsContext.Provider
        value={{
            pxToRem: (px: number) => pxToRem(px, rootHtmlFontSize),
        }}
    >
        {children}
    </EvaneosToolsContext.Provider>
);
